export const RESCHEDULE = 'RESCHEDULE';

export const reschedule = (stats: any) => ({
  type:RESCHEDULE,
  payload: stats
});